import { render } from "./NewsletterSectionComponent.vue?vue&type=template&id=caa380dc&scoped=true"
import script from "./NewsletterSectionComponent.vue?vue&type=script&lang=js"
export * from "./NewsletterSectionComponent.vue?vue&type=script&lang=js"

import "./NewsletterSectionComponent.vue?vue&type=style&index=0&id=caa380dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa380dc"]])

export default __exports__